import styled from 'styled-components';

export const StyledMessageBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 350px;
    width: 100%;
    padding: 1em;
    border: ${(props: any) => '2px solid ' + props.borderColor};
    border-radius: 7px;
    background: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    font-family: ${(props: any) => props.fontFamily};
    .message_box_title {
        margin: 12px 0 0 0;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-align: center;
        text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.8);
    }
    .message_box_text {
        margin: 4px 0 0 0;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        white-space: pre-line;
    }
    .message_box_logo {
        width: auto;
        max-height: 160px;
        object-fit: contain;
    }
` as any;
